var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('b-container',[_c('span',[_vm._v("Copyright © SpongePowered 2014-"+_vm._s(new Date().getFullYear()))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }